import { defineMessages } from 'react-intl';

const messages = defineMessages({
  uploadDesc: '请上传供应商营业执照、五证合一等相关资质文件及公司案例团队介绍。',
  uploadDescTip: '（ 如属纯资源执行型公司需提交资源价格列表 ）',
  uploadTip: '（ 格式不限，单个文件不能超过200M ）',
});

export default messages;
